import { Routes } from '@angular/router';
import { HomeSigesrComponent } from './home-sigesr/home-sigesr';
import { AuthGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    component: HomeSigesrComponent,
    canActivate: [AuthGuard],
    title: 'Applications | SIGESR'
  },
  {
    path: '**',
    redirectTo: ''
  }
];